export const globalStyleObj = {
  // Pages
  authSectionContainer: "w-full min-h-[100vh] bg-[#F3F3F9]",
  initialPageStyle: "min-h-[calc(100vh-110px)] bg-transparent",
  // Auth
  authFormContainer: "w-full px-2",
  authBannerText: "text-[#ffffff] font-poppins-md text-[15px] text-center",
  mainFormContainer:
    "relative -top-[100px] sm:-top-[200px] lg:-top-[100px] z-[50] flex flex-col items-center justify-center gap-5",
  formInnerContainer:
    "bg-white w-full max-w-[450px] px-5 sm:px-8 py-8 rounded-md shadow-light",
  formHeading:
    "mb-2 text-center font-poppins-sb text-light-weight-500 text-[16px]",
  formDescription:
    "text-[13px] font-poppins-md text-light-weight-400 text-center",
  formLabelText: "text-[13px] font-poppins-md text-dark-weight-500",
  formInputText: "text-[13px] font-poppins-rg  text-dark-weight-500",
  authDescription: "text-[#878A99] font-poppins-rg text-sm",
  authButton:
    "bg-orange-500/80 hover:bg-orange-500 transition-300 text-white text-[14px] font-poppins-rg px-2 py-2 rounded-md flex justify-center items-center",
  authDescriptionText: "text-dark-weight-500 font-poppins-md text-[13px]",

  // Flex Container
  flexCenter: "flex justify-center items-center",
  flexBetween: "flex justify-between items-center",
  flexColCenter: "flex flex-col justify-center items-center",
  flexStart: "flex justify-start items-center",
  flexColStart: "flex flex-col justify-start items-center",

  // Background
  backgroundLight900Dark200: "bg-light-dencity-900 dark:bg-dark-dencity-200",
  backgroundLight900Dark250: "bg-light-dencity-900 dark:bg-dark-dencity-250",
  backgroundLight900Dark300: "bg-light-dencity-900 dark:bg-dark-dencity-300",
  backgroundLight800Dark600: "bg-light-dencity-800 dark:bg-dark-dencity-600",
  backgroundLight800Dark300: "bg-light-dencity-800 dark:bg-dark-dencity-300",
  backgroundLight800Dark100: "bg-light-dencity-800 dark:bg-dark-dencity-100",
  backgroundLight700Dark220: "bg-light-dencity-700 dark:bg-dark-dencity-220",
  backgroundLight400Dark100: "bg-light-dencity-400 dark:bg-dark-dencity-100",
  backgroundLight200Dark350: "bg-light-dencity-200 dark:bg-dark-dencity-350",

  bgColorYankeesBlue: "bg-accent-yankees-blue",
  bgSidebarColorDarkTealGreen: "bg-[#066b5e]",
  bgSidebarColorRoyalPurple: "bg-[#5147A3]",
  bgSidebarColorCobalBlue: "bg-[#2a5fc1]",

  bgSidebarColorGradientParent: "bg-gradient-to-r from-[#3d578a] to-[#10a99a]",
  bgSidebarColorGradientFirstChild:
    "bg-gradient-to-r from-[#3d578a] to-[#10a99a]",
  bgSidebarColorGradientSecondChild:
    "bg-gradient-to-r from-[#2a99dd] to-[#347cef]",
  bgSidebarColorGradientThirdChild:
    "bg-gradient-to-r from-[#2a99dd] to-[#0fb0a6]",
  bgSidebarColorGradientFourthChild:
    "bg-gradient-to-r from-[#1d2129] to-[#3b4b7d]",

  // Icons
  iconLight450Dark350: "text-light-weight-450 dark:text-dark-weight-350",
  topbarDarkIconColor: "text-[#B0B5BC]",
  topbarDarkBoxColor: "bg-[#4A5A8F]",
  topbarDarkToggleBarColor: "bg-[#B0B5BC]",
  topbarDarkProfileBgColor: "bg-[#536395]",

  // Text
  textSoft: "text-[#8A8D9C] font-poppins-rg",
  textDark: "text-[#545A61] font-poppins-md",
  text22BoldLight550Dark550:
    "text-dark-weight-550 dark:text-light-weight-550 font-poppins-md text-[22px]",
  text16BoldLight550Dark550:
    "text-dark-weight-550 dark:text-light-weight-550 font-poppins-bold text-[16px]",
  text16Light550Dark550:
    "text-dark-weight-550 dark:text-light-weight-550 font-poppins-sb text-[16px]",
  text16RgLight600Dark600:
    "text-dark-weight-550 dark:text-light-weight-600 font-poppins-rg text-[16px]",
  text13Light550Dark550:
    "text-dark-weight-550 dark:text-light-weight-550 font-poppins-rg text-[13px]",
  text13Light550Dark550Md:
    "text-dark-weight-550 dark:text-light-weight-550 font-poppins-md text-[13px]",
  text13Light550Dark550Sb:
    "text-dark-weight-550 dark:text-light-weight-550 font-poppins-sb text-[13px]",
  text13Light600Dark400:
    "text-dark-weight-600 dark:text-light-weight-400 font-poppins-rg text-[13px]",
  text13Light600Dark450:
    "text-dark-weight-600 dark:text-light-weight-450 font-poppins-md text-[13px]",
  text11Light400Semibold: "text-[11px] text-light-weight-450 font-poppins-sb",
  text11Light400: "text-[11px] text-light-weight-400 font-poppins-rg",
  text13Light400: "text-[13px] text-light-weight-400 font-poppins-rg",

  // Navbar
  navInnerButton:
    "bg-[#e1ebfd] dark:bg-[#2b394f] flex items-center gap-1 rounded-full px-3 py-1 hover:bg-[#568df3] hover:text-white",

  // Right Sidebar
  layoutBoxBackgroundLightDark: "bg-light-dencity-700 dark:bg-[#383838]",
  layoutInnerBoxBackgroundLightDark: "bg-light-dencity-100 dark:bg-[#494b52]",

  // Forms
  commonInputContainerClass:
    "flex w-full flex-col justify-between gap-3 xl:flex-row",
  commonDefaultInputFieldClass:
    "w-full max-w-[800px] border border-[#000]/20 font-poppins-rg text-[13px] text-light-weight-400 focus-visible:outline-none focus-visible:ring-0 dark:border-[#fff]/10 dark:bg-[#000]/10 dark:text-light-weight-400",
  commonInputErrorClass: "text-red-500 text-[13px] font-poppins-rg",

  // Settings Form
  commonSettingInputContainerClass:
    "flex flex-col gap-2 xl:flex-row justify-between lg:gap-5",
  commonSettingInputFieldClass:
    "w-full border border-[#000]/20 font-poppins-rg text-[13px] text-light-weight-400 focus-visible:outline-none focus-visible:ring-0 dark:border-[#fff]/10 dark:bg-[#000]/10 dark:text-light-weight-400",

  // Miscellaneous
  noFocus:
    "focus-visible:ring-0 focus-visible:ring-transparent focus-visible:ring-offset-0",
};
